// LACE Risk Score Constants
export const Q1_STAY_OPTIONS = [
    { value: '0', label: 'Select length of stay', points: 0 },
    { value: '1', label: '1 Day (1 point)', points: 1 },
    { value: '2', label: '2 Days (2 points)', points: 2 },
    { value: '3', label: '3 Days (3 points)', points: 3 },
    { value: '4', label: '4-6 Days (4 points)', points: 4 },
    { value: '5', label: '7-13 Days (5 points)', points: 5 },
    { value: '7', label: '14 or more Days (7 points)', points: 7 }
];

export const Q2_OPTIONS = [
    { value: '0', label: 'No (0 points)', points: 0 },
    { value: '3', label: 'Yes, admitted via emergency department (3 points)', points: 3 }
];

export const Q3_VISITS_OPTIONS = [
    { value: '', label: 'Select visits', points: 0 },
    { value: '0', label: '0 (0 points)', points: 0 },
    { value: '1', label: '1 (1 point)', points: 1 },
    { value: '2', label: '2 (2 points)', points: 2 },
    { value: '3', label: '3 (3 points)', points: 3 },
    { value: '4', label: '4 or more (4 points)', points: 4 }
];

export const COMORBIDITY_OPTIONS = [
    {
        label: 'Previous myocardial infarction',
        value: 1,
        description: 'Any previous definite or probable myocardial infarction (1 point)'
    },
    {
        label: 'Cerebrovascular disease',
        value: 1,
        description: 'Any previous stroke or transient ischemic attack (TIA) (1 point)'
    },
    {
        label: 'Peripheral vascular disease',
        value: 1,
        description: 'Intermittent claudication, previous surgery or stenting, gangrene or acute ischemia, untreated abdominal or thoracic aortic aneurysm (1 point)'
    },
    {
        label: 'Diabetes without complications',
        value: 1,
        description: 'No retinopathy, nephropathy or neuropathy (1 point)'
    },
    {
        label: 'Congestive heart failure',
        value: 2,
        description: 'Any patient with symptomatic CHF whose symptoms have responded to appropriate medications (2 point)'
    },
    {
        label: 'Diabetes with end organ damage',
        value: 2,
        description: 'Diabetes with retinopathy, nephropathy or neuropathy (2 point)'
    },
    {
        label: 'Chronic pulmonary disease',
        value: 2,
        description: 'Types of chronic lung disease include asthma, chronic obstructive pulmonary disease (COPD), pulmonary fibrosis, asbestosis, pneumonitis, and other lung conditions (2 point)'
    },
    {
        label: 'Mild liver or renal disease',
        value: 2,
        description: 'Cirrhosis but no portal hypertension (i.e., no varices, no ascites) OR chronic hepatitis. Chronic Renal Disease (2 point)'
    },
    {
        label: 'Any tumor (including lymphoma or leukemia)',
        value: 2,
        description: 'Solid tumors must have been treated within the last 5 years; includes chronic lymphocytic leukemia (CLL) and polycythemia vera (PV) (2 point)'
    },
    {
        label: 'Dementia',
        value: 3,
        description: 'Any cognitive deficit (3 points)'
    },
    {
        label: 'Connective tissue disease',
        value: 3,
        description: 'Systemic lupus erythematosus (SLE), polymyositis, mixed connective tissue disease, moderate to severe rheumatoid arthritis, and polymyalgia rheumatica (3 points)'
    },
    {
        label: 'AIDS',
        value: 4,
        description: 'AIDS-defining opportunistic infection or CD4 < 200 (4 points)'
    },
    {
        label: 'Moderate or severe liver or renal disease',
        value: 4,
        description: 'Cirrhosis with portal hypertension (e.g., ascites or variceal bleeding). Endstage Renal Disease, Hemodialysis or Peritoneal Dialysis (4 points)'
    },
    {
        label: 'Metastatic solid tumor',
        value: 6,
        description: 'Any Metastatic Tumour (6 points)'
    }
];

export const QUESTION_TITLES = {
    1: 'Has the patient been admitted to the Hospital in the last 6 months?',
    2: 'Acuity of Admission',
    3: 'Emergency Department Visits',
    4: 'Comorbidities'
};